import { defineStore } from 'pinia';

export const useSelectedTabsStore = defineStore('selectedTabs', {
  state: (): { selectedTabs: Record<string, string> } => ({
    selectedTabs: {},
  }),
  actions: {
    setSelectedTab(dataKey: string, tab: string) {
      this.selectedTabs[dataKey] = tab;
    },
    getSelectedTab(dataKey: string) {
      return this.selectedTabs[dataKey] || null;
    },
  },
  persist: {
    storage: localStorage,
  },
});
